import { render } from "./DynamicEmbed.vue?vue&type=template&id=4308754e"
import script from "./DynamicEmbed.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicEmbed.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/DynamicPlayer/DynamicEmbed.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4308754e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4308754e', __exports__)) {
    api.reload('4308754e', __exports__)
  }
  
  module.hot.accept("./DynamicEmbed.vue?vue&type=template&id=4308754e", () => {
    api.rerender('4308754e', render)
  })

}


export default __exports__